module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Card', [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(" Tambah Nota Transaksi ")]), _vm._v(" "), _c('Row', {
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('Col', {
    attrs: {
      "span": "9"
    }
  }, [_c('ButtonGroup', {
    staticClass: "custom-group-parent"
  }, [_c('Button', {
    staticClass: "custom-group"
  }, [_vm._v("Bank Account")]), _vm._v(" "), _c('Select', {
    attrs: {
      "placeholder": "Select Bank",
      "clearable": "",
      "filterable": ""
    },
    on: {
      "on-change": _vm.updateFilter
    },
    model: {
      value: (_vm.bankAccountId),
      callback: function($$v) {
        _vm.bankAccountId = $$v
      },
      expression: "bankAccountId"
    }
  }, _vm._l((_vm.bankAccounts), function(bankAccount) {
    return _c('Option', {
      key: bankAccount.id,
      attrs: {
        "value": bankAccount.id
      }
    }, [_vm._v(_vm._s(bankAccount.accountName))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('ButtonGroup', {
    staticClass: "custom-group-parent"
  }, [_c('Button', {
    staticClass: "custom-group"
  }, [_vm._v("Tgl. Transaksi")]), _vm._v(" "), _c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Select Date",
      "type": "daterange",
      "format": "yyyy-MM-dd"
    },
    on: {
      "on-change": _vm.updateFilter
    },
    model: {
      value: (_vm.filterTransactionDate),
      callback: function($$v) {
        _vm.filterTransactionDate = $$v
      },
      expression: "filterTransactionDate"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('ButtonGroup', {
    staticClass: "custom-group-parent"
  }, [_c('Button', {
    staticClass: "custom-group"
  }, [_vm._v("Marking    ")]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Select Marking",
      "filterable": "",
      "clearable": "",
      "remote-method": _vm.getMarkingByCode,
      "loading": _vm.isLoadingMarking
    },
    on: {
      "on-change": _vm.updateFilter
    },
    model: {
      value: (_vm.markingIdSelected),
      callback: function($$v) {
        _vm.markingIdSelected = $$v
      },
      expression: "markingIdSelected"
    }
  }, _vm._l((_vm.optionMarkings), function(option) {
    return _c('Option', {
      key: option.value,
      attrs: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.label))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "2"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "icon": "ios-search",
      "disabled": !_vm.isSearchShow
    },
    on: {
      "click": _vm.getTransactionNote
    }
  }, [_c('span', [_vm._v("Cari")])])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('Card', [_c('Table', {
    attrs: {
      "columns": _vm.columnsDataTable,
      "data": _vm.transactionNoteData
    },
    on: {
      "on-selection-change": _vm.onSelectionChange
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.transactionNoteCreate.length > 0),
      expression: "transactionNoteCreate.length > 0"
    }],
    staticClass: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "success",
      "icon": "plus",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.modalConfirmMultipleCreate = true
      }
    }
  }, [_c('span', [_vm._v("Create nota transaksi")])])], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "50rem"
    },
    model: {
      value: (_vm.modalConfirmMultipleCreate),
      callback: function($$v) {
        _vm.modalConfirmMultipleCreate = $$v
      },
      expression: "modalConfirmMultipleCreate"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#f60",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Konfirmasi")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "left"
    }
  }, _vm._l((_vm.transactionNoteCreate), function(data) {
    return _c('div', [_c('Tag', {
      attrs: {
        "color": "blue"
      }
    }, [_vm._v(" Marking : " + _vm._s(data.markingheadercode) + " | " + _vm._s(data.paymentDate) + " | " + _vm._s(_vm.cleanDescription(data.description)))])], 1)
  }), 0), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "error",
      "size": "large",
      "long": "",
      "icon": "plus",
      "loading": _vm.isCreate
    },
    on: {
      "click": function($event) {
        return _vm.createTransactionNote(_vm.transactionNoteCreate)
      }
    }
  }, [_vm._v("Create nota transaksi")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d3a4a98","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/payment/PaymentTransactionNoteNew.vue
// module id = 1825
// module chunks = 1